import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import sal from 'sal.js';
import 'sal.js/dist/sal.css';

const SectionTitle = ({ blok }) => {
  let headingElement;
  const headingClass = 'font-heading text-sm uppercase lg:text-xl xl:text-2.5xl';

  useEffect(() => {
    if (blok.animate) {
      sal({ threshold: 0.25 });
    }
  }, [blok.animate]);

  if (blok.top_title) {
    headingElement = <h1 className={headingClass}>{blok.title}</h1>;
  } else {
    headingElement = <h3 className={headingClass}>{blok.title}</h3>;
  }

  return (
    <div
      className={`container py-7 lg:py-8 xl:py-10 ${
        blok.top_title ? 'pt-14 lg:pt-16 xl:pt-20' : ''
      }`}
      {...(blok.animate
        ? {
            'data-sal': 'slide-up',
            'data-sal-duration': '1000',
            'data-sal-delay': '0',
            'data-sal-easing': 'ease',
          }
        : {})}
    >
      {headingElement}
    </div>
  );
};

export default SectionTitle;

SectionTitle.propTypes = {
  blok: PropTypes.object.isRequired,
};
